/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ContactDetailsCommunicationDataDto,
  ContactDetailsEmployeeCommonDto,
  ContactDetailsEmployeeDto,
  ContactDetailsEmployeePersonalDto,
  ContactDetailsEmployeeSalaryDto,
  EmployeePayBasis,
} from '@gh/builder-shared-data';
import { nullate } from '@gh/core-util';
import { omit } from 'lodash';
import {
  ContactCustomFieldList,
  ContactPaymentPayee,
  ContactTermsPayee,
} from './contact-shared.model';

export type ContactDetailsEmployeePersonal = ContactDetailsEmployeePersonalDto;

export class ContactDetailsEmployeeSalary {
  constructor(
    public payrollCycle?: any,
    public hoursInPayPeriod?: number,
    public payBasis?: any,
    public salary?: number,
    public salaryBasisHourlyRate?: number | null,
    public hourlyBasisHourlyRate?: number | null,
    public commissionRate?: number,
  ) {
  }
}

export class ContactDetailsEmployeeCommon {
  constructor(
    public personal: ContactDetailsEmployeePersonal,
    public salary: ContactDetailsEmployeeSalary,
  ) {
  }
}

export class ContactDetailsEmployee {
  constructor(
    public common: ContactDetailsEmployeeCommon,
    public payment: ContactPaymentPayee,
    public terms: ContactTermsPayee,
    public communication: ContactDetailsCommunicationDataDto,
    public customFields: ContactCustomFieldList,
  ) {

  }
}

export function contactDetailsEmployeeFromDto(dto: ContactDetailsEmployeeDto): ContactDetailsEmployee {
  return {
    ...dto,
    common: contactDetailsEmployeeCommonFromDto(dto.common),
  };
}

export function contactDetailsEmployeeToDto(model: ContactDetailsEmployee): ContactDetailsEmployeeDto {
  return {
    ...<ContactDetailsEmployeeDto>model,
    common: contactDetailsEmployeeCommonToDto(model.common),
  };
}

export function isSalaryBased(salary: ContactDetailsEmployeeSalary): boolean {
  return salary.payBasis === EmployeePayBasis.Salary;
}

export function contactDetailsEmployeeCommonFromDto(dto: ContactDetailsEmployeeCommonDto): ContactDetailsEmployeeCommon {
  return {
    ...dto,
    salary: {
      ...<ContactDetailsEmployeeSalary>omit(dto.salary, 'hourlyRate'),
      salaryBasisHourlyRate: dto.salary.payBasis === EmployeePayBasis.Salary ? dto.salary.hourlyRate : nullate(void 0),
      hourlyBasisHourlyRate: dto.salary.payBasis === EmployeePayBasis.Hourly ? dto.salary.hourlyRate : nullate(void 0),
    },
  };
}

export function contactDetailsEmployeeCommonToDto(model: ContactDetailsEmployeeCommon): ContactDetailsEmployeeCommonDto {
  const { payBasis, salaryBasisHourlyRate, hourlyBasisHourlyRate } = model.salary;

  return {
    ...model,
    salary: {
      ...<ContactDetailsEmployeeSalaryDto>omit(model.salary, 'salaryBasisHourlyRate', 'hourlyBasisHourlyRate'),
      hourlyRate: {
        [EmployeePayBasis.Salary]: salaryBasisHourlyRate,
        [EmployeePayBasis.Hourly]: hourlyBasisHourlyRate,
      }[<string>payBasis],
    },
  };
}
